// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1T_9E","itemTitle":"ClientEmergencyInfo_itemTitle__2csb9","itemText":"ClientEmergencyInfo_itemText__9GN4H"};